import { render } from "./_event.vue?vue&type=template&id=45ce9fbd&scoped=true&lang=pug"
import script from "./_event.vue?vue&type=script&lang=js"
export * from "./_event.vue?vue&type=script&lang=js"

import "./_event.vue?vue&type=style&index=0&id=45ce9fbd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ce9fbd"]])

export default __exports__